import {
  SPAIN_ADDRESS_FLOOR_OPTIONS as _SPAIN_ADDRESS_FLOOR_OPTIONS,
  SPAIN_ADDRESS_DOOR_OPTIONS as _SPAIN_ADDRESS_DOOR_OPTIONS,
  SPAIN_PROVINCE_OPTIONS,
  SPAIN_PROVINCES as _SPAIN_PROVINCES,
} from "../../constants/spainAddressOptions";

export const MOCK_PREFILLED = {
  fullName: "María García López",
  phone: "612 345 678",
  phoneCountryCode: "+34",
  email: "maria.garcia@example.com",
  registrantType: "" as "individual" | "representative" | "",
  advisor: "Ana Travieso",
};

/** Re-export for applicant UI + parse helpers (canonical list in `constants/spainAddressOptions.js`). */
export const SPAIN_ADDRESS_FLOOR_OPTIONS: { value: string; label: string }[] = _SPAIN_ADDRESS_FLOOR_OPTIONS;
export const SPAIN_ADDRESS_DOOR_OPTIONS: { value: string; label: string }[] = _SPAIN_ADDRESS_DOOR_OPTIONS;

/**
 * Parse legacy combined floor+door string (e.g. "3 B", "Bajo") into piso + puerta for the UI.
 * New API stores `floor_piso` + `floor_door` (puerta) separately in Mongo (`piso` + `puerta`).
 */
export function parseStoredFloorDoor(fd: string): { piso: string; door: string } {
  const trimmed = fd.trim();
  if (!trimmed) return { piso: "", door: "" };
  const parts = trimmed.split(/\s+/).filter(Boolean);
  const first = parts[0] ?? "";
  const door = parts.length > 1 ? parts.slice(1).join(" ") : "";

  const norm = first
    .toLowerCase()
    .normalize("NFD")
    .replace(/\u0308/g, "")
    .replace(/[º°.]/g, "");

  if (norm === "bajo") return { piso: "Bajo", door };
  if (norm.startsWith("ent")) return { piso: "Entresuelo", door };
  if (norm === "atico" || norm === "ático") return { piso: "Atico", door };

  const digits = first.replace(/\D/g, "");
  if (digits) {
    const n = parseInt(digits, 10);
    if (n >= 1 && n <= 15) return { piso: String(n), door };
  }

  const knownValues = new Set(SPAIN_ADDRESS_FLOOR_OPTIONS.map((o) => o.value));
  if (knownValues.has(first)) return { piso: first, door };

  return { piso: first, door };
}

export const SPAIN_PROVINCES: string[] = _SPAIN_PROVINCES;

export { SPAIN_PROVINCE_OPTIONS };

export const COUNTRIES = [
  "Afganistán", "Albania", "Alemania", "Andorra", "Angola", "Arabia Saudita",
  "Argelia", "Argentina", "Armenia", "Australia", "Austria", "Azerbaiyán",
  "Bangladés", "Baréin", "Bélgica", "Belice", "Benín", "Bielorrusia",
  "Bolivia", "Bosnia y Herzegovina", "Brasil", "Bulgaria", "Burkina Faso",
  "Burundi", "Cabo Verde", "Camboya", "Camerún", "Canadá", "Catar", "Chad",
  "Chile", "China", "Chipre", "Colombia", "Comoras", "Congo",
  "Corea del Norte", "Corea del Sur", "Costa de Marfil", "Costa Rica",
  "Croacia", "Cuba", "Dinamarca", "Ecuador", "Egipto", "El Salvador",
  "Emiratos Árabes Unidos", "Eritrea", "Eslovaquia", "Eslovenia", "España",
  "Estados Unidos", "Estonia", "Etiopía", "Filipinas", "Finlandia", "Fiyi",
  "Francia", "Gabón", "Gambia", "Georgia", "Ghana", "Grecia", "Guatemala",
  "Guinea", "Guinea Ecuatorial", "Guinea-Bisáu", "Haití", "Honduras",
  "Hungría", "India", "Indonesia", "Irak", "Irán", "Irlanda", "Israel",
  "Italia", "Jamaica", "Japón", "Jordania", "Kazajistán", "Kenia",
  "Kirguistán", "Kosovo", "Kuwait", "Laos", "Letonia", "Líbano", "Liberia",
  "Libia", "Lituania", "Luxemburgo", "Macedonia del Norte", "Madagascar",
  "Malaui", "Malasia", "Malí", "Malta", "Marruecos", "Mauritania",
  "Mauricio", "México", "Moldavia", "Mongolia", "Montenegro", "Mozambique",
  "Myanmar", "Namibia", "Nepal", "Nicaragua", "Níger", "Nigeria", "Noruega",
  "Nueva Zelanda", "Omán", "Países Bajos", "Pakistán", "Palestina",
  "Panamá", "Paraguay", "Perú", "Polonia", "Portugal",
  "Reino Unido", "República Centroafricana", "República Checa",
  "República Democrática del Congo", "República Dominicana", "Ruanda",
  "Rumanía", "Rusia", "Senegal", "Serbia", "Sierra Leona", "Singapur",
  "Siria", "Somalia", "Sri Lanka", "Sudáfrica", "Sudán", "Sudán del Sur",
  "Suecia", "Suiza", "Tailandia", "Taiwán", "Tanzania", "Tayikistán",
  "Togo", "Túnez", "Turquía", "Turkmenistán", "Uganda", "Ucrania",
  "Uruguay", "Uzbekistán", "Venezuela", "Vietnam", "Yemen", "Yibuti",
  "Zambia", "Zimbabue",
];

export const NATIONALITIES_ES: Record<string, string> = {
  "Afganistán": "Afgana", "Albania": "Albanesa", "Argelia": "Argelina",
  "Argentina": "Argentina", "Bangladés": "Bangladesí", "Bolivia": "Boliviana",
  "Brasil": "Brasileña", "Bulgaria": "Búlgara", "Camerún": "Camerunesa",
  "Chile": "Chilena", "China": "China", "Colombia": "Colombiana",
  "Congo": "Congoleña", "Cuba": "Cubana",
  "República Democrática del Congo": "Congoleña (RDC)",
  "República Dominicana": "Dominicana", "Ecuador": "Ecuatoriana",
  "Egipto": "Egipcia", "El Salvador": "Salvadoreña", "Etiopía": "Etíope",
  "Francia": "Francesa", "Gabón": "Gabonesa", "Gambia": "Gambiana",
  "Alemania": "Alemana", "Ghana": "Ghanesa", "Guatemala": "Guatemalteca",
  "Guinea": "Guineana", "Guinea-Bisáu": "Guineana-Bisáu",
  "Haití": "Haitiana", "Honduras": "Hondureña", "India": "India",
  "Indonesia": "Indonesia", "Irán": "Iraní", "Irak": "Iraquí",
  "Italia": "Italiana", "Costa de Marfil": "Marfileña", "Jamaica": "Jamaicana",
  "Jordania": "Jordana", "Kenia": "Keniana", "Libia": "Libia",
  "Malí": "Maliense", "Mauritania": "Mauritana", "México": "Mexicana",
  "Marruecos": "Marroquí", "Mozambique": "Mozambiqueña", "Myanmar": "Myanmar",
  "Nepal": "Nepalesa", "Nicaragua": "Nicaragüense", "Níger": "Nigerina",
  "Nigeria": "Nigeriana", "Pakistán": "Pakistaní", "Palestina": "Palestina",
  "Panamá": "Panameña", "Paraguay": "Paraguaya", "Perú": "Peruana",
  "Filipinas": "Filipina", "Portugal": "Portuguesa", "Rumanía": "Rumana",
  "Rusia": "Rusa", "Ruanda": "Ruandesa", "Arabia Saudita": "Saudí",
  "Senegal": "Senegalesa", "Sierra Leona": "Sierraleonesa", "Somalia": "Somalí",
  "España": "Española", "Sri Lanka": "Esrilanquesa", "Sudán": "Sudanesa",
  "Siria": "Siria", "Tanzania": "Tanzana", "Togo": "Togolesa",
  "Túnez": "Tunecina", "Turquía": "Turca", "Uganda": "Ugandesa",
  "Ucrania": "Ucraniana", "Reino Unido": "Británica",
  "Estados Unidos": "Estadounidense", "Uruguay": "Uruguaya",
  "Venezuela": "Venezolana", "Vietnam": "Vietnamita", "Yemen": "Yemení",
  "Zambia": "Zambiana", "Zimbabue": "Zimbabuense",
};
